import * as TK from 'components/site/SiteAvatarImageCropDialog/translations/constants';
import { Translations } from 'translations/types';

export const siteAvatarImageCropDialogEnUsLocale: Translations = {
  [TK.SITE_AVATAR_IMAGE_CROP_DIALOG_TITLE_DESKTOP]: 'Upload Your Photo',
  [TK.SITE_AVATAR_IMAGE_CROP_DIALOG_TITLE_MOBILE]: 'Select Picture',
  [TK.SITE_AVATAR_IMAGE_CROP_DIALOG_CANCEL_BUTTON_TEXT]: 'Cancel',
  [TK.SITE_AVATAR_IMAGE_CROP_DIALOG_SAVE_BUTTON_TEXT]: 'Save',
};
